import DiscountRatesTableWidget from "./components/widget/DiscountRatesTableWidget";
import DiscountRateEditWidget from "./components/widget/DiscountRateEditWidget";
import discountRateStore from "./store/discountRateStore";

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }
    options.store.registerModule('discountRatesPlugin', discountRateStore);

    Vue.component('DiscountRatesTableWidget', DiscountRatesTableWidget);
    Vue.component('DiscountRateEditWidget', DiscountRateEditWidget);
  },
};
